import { InjectionToken } from '@angular/core'
import { Converter } from '@spartacus/core'
import { AcademicDegree } from '../../../models'

export const MB_ACADEMIC_DEGREE_NORMALIZER = new InjectionToken<Converter<any, AcademicDegree[]>>('MbAcademicDegreeNormalizer')
